export const defaultNumberOfRecords = [5, 10, 15, 20, 25, 50, 100]
